module.exports = __webpack_public_path__ + "static/media/campusImgE.eb95853a.png";